// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__b3hHeK"};